/**
 * Partner dashboard page (epic-6) — route: /dashboard/:campaignId
 *
 * Thin page shell: chrome (skip link, nav, footer) + the CampaignDashboard
 * feature for the campaign in the URL. Authenticated-in-intent (internal-staff
 * stub today; partner-scoped auth is the v1-2-6 deferral), so this route is NOT
 * added to the sitemap / robots — it is not a public, crawlable page.
 */
import { useParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CampaignDashboard } from '../features/dashboard/CampaignDashboard';

export function DashboardPage() {
  const { campaignId } = useParams<{ campaignId: string }>();

  return (
    <div className="min-h-screen bg-surface-alt">
      <a
        href="#dashboard-main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-primary px-4 py-2 focus:text-white"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="dashboard-main" className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        {campaignId ? (
          <CampaignDashboard campaignId={campaignId} />
        ) : (
          <div className="rounded-2xl border border-line bg-white p-8 text-center shadow-card">
            <p className="text-sm text-ink-700">
              No campaign selected. Open a campaign dashboard from your campaign
              link.
            </p>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default DashboardPage;
